var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "threadPreview" } },
    [
      _c("div", { staticClass: "thread-subject" }, [
        _vm._v("\n        " + _vm._s(_vm.thread.folderName) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "el-scrollbar",
        { ref: "elscrollbar", staticStyle: { height: "calc(100% - 70px)" } },
        _vm._l(_vm.emails, function(email, index) {
          return _c(
            "div",
            {
              key: index,
              staticStyle: { "padding-right": "30px", "margin-bottom": "20px" }
            },
            [
              _vm.haveDevelop(index)
                ? _c(
                    "div",
                    [
                      _c("emailPage", {
                        ref: "emailPage",
                        refInFor: true,
                        attrs: { email: email }
                      }),
                      _vm._v(" "),
                      _c("hr", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.emails.length > 1,
                            expression: "emails.length>1"
                          }
                        ]
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              index == 0 && !_vm.isDevelop && _vm.emails.length > 4
                ? _c("div", { staticClass: "emails-abbreviation" }, [
                    _c(
                      "div",
                      {
                        staticClass: "emails-abbreviation-btn",
                        on: {
                          click: function($event) {
                            _vm.isDevelop = true
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/images/vectorImg/icon_hide_mail_expand.svg")
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.emails.length - 3))])
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr")
                  ])
                : _vm._e()
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29c594dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c594dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/thread_preview.vue
// module id = null
// module chunks = 